import EventEmitter from "eventemitter3";

// Events fired from inside the report renderer itself. They live here rather
// than on each app's own event bus because the emitters (a `{{cite:…}}`
// superscript, an auto-linked norm, a "see section" link) ship with the
// renderer, while the listeners live in the host app (user-interface mounts
// the citation panel and the norma modal; admin-interface mounts neither).
type ReportEventTopics =
  // Payload: the citation's key into the report's CitationsMap.
  | "REPORT_OPEN_CITATION"
  // Payload: { label, url, text? } for one recognized legal norm.
  | "REPORT_OPEN_NORMA"
  // Payload: the DOM id of the section to scroll to.
  | "REPORT_SCROLL_TO_SECTION";

export const reportEventBus = new EventEmitter<ReportEventTopics>();
